"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downexInstructions = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const __1 = require("../../..");
const taskStore_1 = require("../../../taskStore");
const helpers_1 = require("../../shared/helpers");
const animate_1 = require("../helpers/animate");
const taskSetup_1 = require("../../taskSetup");
const pulseOkButton_1 = require("../../shared/helpers/pulseOkButton");
const replayButtonHtmlId = 'replay-btn-revisited';
let cycleId = 0; // disable audio if the trial has changed since the loop started - prevent overlapping audio
const downexData = [
    {
        audio: ['mental-rotation-instruct1-part1-downex', 'mental-rotation-instruct1-part2-downex'],
        choices: ['Rp-000-silh', 'Rn-000-silh'],
        image: 'Rp-000-gray',
        animations: [
            {
                item: 'stim-image',
                animation: 'pulse',
            },
        ],
        eventOrder: ['audio', 'animation', 'audio'],
    },
    {
        audio: ['mental-rotation-instruct2-downex', 'mental-rotation-instruct3-downex'],
        choices: ['Rp-000-silh', 'Rn-000-silh'],
        image: 'Rp-000-gray',
        animations: [
            {
                item: 'distractor',
                animation: 'pulse',
            },
            {
                item: 'distractor',
                animation: 'drag',
            },
        ],
        eventOrder: ['audio', 'animation', 'animation', 'audio'],
    },
    {
        audio: ['mental-rotation-instruct2-downex', 'mental-rotation-instruct4-downex'],
        choices: ['Rp-000-silh', 'Rn-000-silh'],
        image: 'Rp-000-gray',
        animations: [
            {
                item: 'target',
                animation: 'pulse',
            },
            {
                item: 'target',
                animation: 'drag',
            },
        ],
        eventOrder: ['audio', 'animation', 'animation', 'audio'],
    },
];
let startTime;
exports.downexInstructions = downexData.map((data) => {
    return {
        type: plugin_html_multi_response_1.default,
        stimulus: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            const stimImage = __1.mediaAssets.images[(0, helpers_1.camelize)(data.image)];
            const itemText = data.audio.map((file) => t[(0, helpers_1.camelize)(file)]).join(' ');
            return `<div class="lev-stimulus-container">
                  ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
                  <div class="lev-row-container instruction-small">
                      <p>${itemText}</p>
                  </div>

                  <div id="stim-container" class="lev-stim-content"">
                    <img
                        id="stim-image"
                        src=${stimImage}
                        alt="Image not loading: ${data.image}. Please continue the task."
                    />
                  </div>

                  <div id="choices-container" class="lev-response-row multi-4" style="gap: 16px; margin-top: 16px">
                    <button id="target" class="image-large no-pointer-events" disabled>
                      <img src=${__1.mediaAssets.images[(0, helpers_1.camelize)(data.choices[0])]} alt=${data.choices[0]} />
                    </button>
                    <button id="distractor" class="image-large no-pointer-events" disabled>
                      <img src=${__1.mediaAssets.images[(0, helpers_1.camelize)(data.choices[1])]} alt=${data.choices[1]} />
                    </button>
                  </div>
              </div>`;
        },
        prompt_above_buttons: true,
        button_choices: ['Next'],
        button_html: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            return [`<button class="primary" disabled>${t.continueButtonText}</button>`];
        },
        keyboard_choices: () => 'NO_KEYS',
        on_load: async () => {
            startTime = performance.now();
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
            const replayButton = document.getElementById(replayButtonHtmlId);
            if (replayButton) {
                replayButton.addEventListener('click', () => {
                    animateAndPlayAudio();
                });
            }
            function animateAndPlayAudio() {
                var _a;
                cycleId++;
                const thisCycleId = cycleId;
                // replay button and ok button should be disabled while animations are happening
                if (replayButton) {
                    replayButton.disabled = true;
                }
                (0, helpers_1.disableOkButton)();
                // Preserve stim-container height before animation
                const stimContainer = document.getElementById('stim-container');
                const stimImage = document.getElementById('stim-image');
                if (stimContainer && stimImage) {
                    const imageHeight = stimImage.offsetHeight;
                    stimContainer.style.minHeight = `${imageHeight}px`;
                }
                // create copies of the trial data to avoid mutating the original data
                const trialAudio = [...data.audio];
                const trialAnimations = [...data.animations];
                const trialEventOrder = [...data.eventOrder];
                // reset stim image to its original position
                if (stimImage) {
                    stimImage.style.position = '';
                    stimImage.style.left = '';
                    stimImage.style.top = '';
                    stimImage.style.zIndex = '';
                }
                // reset target source
                const target = (_a = document.getElementById('target')) === null || _a === void 0 ? void 0 : _a.children[0];
                if (target) {
                    target.src = __1.mediaAssets.images[(0, helpers_1.camelize)(data.choices[0])];
                }
                const audioConfig = {
                    restrictRepetition: {
                        enabled: false,
                        maxRepetitions: 2,
                    },
                    onEnded: () => {
                        triggerNextEvent();
                    },
                };
                function triggerNextEvent() {
                    if (thisCycleId !== cycleId || (0, taskStore_1.taskStore)().isPaused) {
                        return;
                    }
                    if (trialEventOrder.length === 0) {
                        (0, helpers_1.enableOkButton)();
                        (0, pulseOkButton_1.pulseOkButton)(3000, (0, taskStore_1.taskStore)().totalTrialCount);
                        if (replayButton) {
                            replayButton.disabled = false;
                        }
                        return;
                    }
                    const event = trialEventOrder.shift();
                    if (event === 'audio') {
                        helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(trialAudio.shift())], audioConfig);
                    }
                    else if (event === 'animation') {
                        const animationObject = trialAnimations.shift();
                        (0, animate_1.animate)(animationObject.animation, animationObject.item);
                        setTimeout(triggerNextEvent, 2000);
                    }
                }
                triggerNextEvent();
            }
            animateAndPlayAudio();
        },
        on_finish: () => {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            cycleId++;
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
                assessment_stage: 'instructions',
            });
        },
    };
});
